import moment from 'jalali-moment'
interface IItemProps {
    item: IRequestMessageResult
}
export default function Item({ item }: IItemProps) {
    return (
        // list_item_message.xml: cnsRoot marginTop/Bottom 4dp, no background
        <div className="my-1">
            {/* Date/time header (list_item_message.xml): txtDate start, txtTime end.
                hamyan_dark_gray #888888, font_size_base 14sp, regular. No divider lines. */}
            <div className="flex items-baseline px-4">
                <span className="text-sm font-normal text-[#888888]">
                    {moment
                        .from(item.date, 'en', 'YYYY-MM-DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                </span>
                <span className="ms-2 flex-1 text-right text-sm font-normal text-[#888888]">
                    {moment(new Date(item.timestamp * 1000))
                        .locale('fa')
                        .fromNow()}
                </span>
            </div>

            {/* rcvMessages: paddingTop/Bottom 4dp */}
            <div className="py-1">
                {item.messages.map((message, index) => (
                    // list_item_message_item.xml: cnsRoot marginTop/Bottom 4dp,
                    // padding 16dp/10dp, 10dp radius. MessageListItemAdapter.bindTo:
                    // seen -> flat white; unseen -> #E2EED9 fill + 1dp colorPrimary stroke.
                    <div
                        className={`mx-4 my-1 rounded-[10px] px-4 py-2.5 ${
                            message.is_seen
                                ? 'bg-white'
                                : 'border border-green-1 bg-[#E2EED9]'
                        }`}
                        key={index}
                    >
                        {/* txtMessage: font_size_base 14sp, bold, dark_text_color #575756 */}
                        <p className="text-sm font-bold text-text-body">
                            {message.body}
                        </p>
                        {/* txtTime: marginTop 8dp, font_size_small 12sp, regular, hamyan_dark_gray #888888 */}
                        <p className="mt-2 text-xs font-normal text-[#888888]">
                            {moment(new Date(message.timestamp * 1000))
                                .locale('fa')
                                .format('HH:mm:ss')}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}
